import { render, staticRenderFns } from "./IpfTableForObligation.vue?vue&type=template&id=c7f0cb72&scoped=true&"
import script from "./IpfTableForObligation.vue?vue&type=script&lang=ts&"
export * from "./IpfTableForObligation.vue?vue&type=script&lang=ts&"
import style0 from "./IpfTableForObligation.vue?vue&type=style&index=0&id=c7f0cb72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f0cb72",
  null
  
)

export default component.exports